var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.114,
    height: 29.521,
    viewBox: "0 0 27.114 29.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alarm",
    transform: "translate(-350.5 -1176.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24.114,19.894H0S4.019,17.241,4.019,7.958a8.038,8.038,0,0,1,16.076,0C20.095,17.241,24.114,19.894,24.114,19.894Z",
    transform: "translate(352 1178)",
    fill: "none",
    stroke: "#00b26b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M4.635,0A2.684,2.684,0,0,1,2.318,1.324,2.684,2.684,0,0,1,0,0",
    transform: "translate(361.739 1203.197)",
    fill: "none",
    stroke: "#00b26b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.323301462c1d4d06011fc460a3b137d8.svg";
export { ForwardRef as ReactComponent };